import React from 'react';
import { Box, Typography } from '@mui/material';
import blueplane from './icons/blueplane.png';
import bluecopter from './icons/bluecopter.png';
import bluerover from './icons/bluerover.png';
import greenplane from './icons/greenplane.png';
import greencopter from './icons/greencopter.png';
import greenrover from './icons/greenrover.png';
import orangeplane from './icons/orangeplane.png';
import orangecopter from './icons/orangecopter.png';
import orangerover from './icons/orangerover.png';
import redplane from './icons/redplane.png';
import redcopter from './icons/redcopter.png';
import redrover from './icons/redrover.png';

const VehicleIconList = [
    {"Plane": redplane, "QuadPlane": redplane, "Copter": redcopter, "Rover": redrover},
    {"Plane": blueplane, "QuadPlane": blueplane, "Copter": bluecopter, "Rover": bluerover},
    {"Plane": greenplane, "QuadPlane": greenplane, "Copter": greencopter, "Rover": greenrover},
    {"Plane": orangeplane, "QuadPlane": orangeplane, "Copter": orangecopter, "Rover": orangerover},
];

const VehicleMaterialColorList = ['red', 'blue', 'green', 'orange'];
const MarkerColorList = ['red', 'blue', 'green', 'orange'];

const getVehicleIcon = (index, mavTypeName) => {
    let typeName = "Plane";
    if (mavTypeName !== undefined) {
        typeName = mavTypeName;
    }
    if (index >= VehicleIconList.length) {
        let newIndex = index % VehicleIconList.length;
        return VehicleIconList[newIndex][typeName];
    } else {
        return VehicleIconList[index][typeName];
    }
}

const getVehicleMaterialColor = (index) => {
    if (index >= VehicleMaterialColorList.length) {
        let newIndex = index % VehicleMaterialColorList.length;
        return VehicleMaterialColorList[newIndex];
    } else {
        return VehicleMaterialColorList[index];
    }
}

const getMarkerColor = (index) => {
    if (index >= MarkerColorList.length) {
        let newIndex = index % MarkerColorList.length;
        return MarkerColorList[newIndex];
    } else {
        return MarkerColorList[index];
    }
}

const VehicleMapIcon = ({index, yaw, mavId, mavTypeName, selectedMavId, handleMavIdSelect}) => {
    const iconSrc = getVehicleIcon(index, mavTypeName);
    const yawDegrees = yaw * 180 / Math.PI;

    let isSelected = mavId == selectedMavId;
    const handleClick = (event) => {
        handleMavIdSelect(mavId);
    };
    return (
        <Box
            sx={{
                width: '60px',
                height: '60px',
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                '&:hover': {
                    border: '2px solid white',
                    borderRadius: '8px'
                },
            }}
            onClick={handleClick}
        >
            <img
                style={{
                    width: '100%',
                    height: '100%',
                    transform: `rotate(${yawDegrees}deg)`
                }}
                src={iconSrc}
            />
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: `${isSelected? '18px' : '15px'}`,
                    height: '15px',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '3px'
                }}
            >
                <Typography
                    sx={{
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }}
                >
                    {`${mavId}${isSelected? '*' : ''}`}
                </Typography>
            </Box>
        </Box>
    );
};

class TargetPositionMarker {
    constructor(index) {
        const color = getMarkerColor(index);
        this.element = document.createElement('div');
        this.element.className = 'target-position-marker';
        this.element.style.width = '25px';
        this.element.style.height = '25px';
        this.element.style.backgroundColor = color;
        this.element.style.borderRadius = '50%';
        this.element.style.display = 'flex';
        this.element.style.alignItems = 'center';
        this.element.style.justifyContent = 'center';
        this.element.style.color = 'white';
        this.element.style.fontWeight = 'bold';
        this.element.innerText = 'T';
    }

    getElement() {
        return this.element;
    }
}

class HomePositionMarker {
    constructor(index) {
        const color = getMarkerColor(index);
        this.element = document.createElement('div');
        this.element.className = 'home-position-marker';
        this.element.style.width = '25px';
        this.element.style.height = '25px';
        this.element.style.backgroundColor = color;
        this.element.style.borderRadius = '50%';
        this.element.style.display = 'flex';
        this.element.style.alignItems = 'center';
        this.element.style.justifyContent = 'center';
        this.element.style.color = 'white';
        this.element.style.fontWeight = 'bold';
        this.element.innerText = 'H';
    }

    getElement() {
        return this.element;
    }
}

const createOrUpdateLine = (map, lineId, coordinates) => {
    if (!map.getSource(lineId)) {
        // Add line source
        map.addSource(lineId, {
            type: 'geojson',
            data: {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'LineString',
                    coordinates: coordinates
                }
            }
        });

        // Add line layer
        map.addLayer({
            id: lineId,
            type: 'line',
            source: lineId,
            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#00ff00',
                'line-width': 2
            }
        });
    } else {
        // Update existing line
        const source = map.getSource(lineId);
        source.setData({
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'LineString',
                coordinates: coordinates
            }
        });
    }
};

const updateTrajectoryLayer = (map, trajectory, mavId) => {
    const color = getVehicleMaterialColor(trajectory[mavId].index);
    const layerId = `trajectory-${mavId}`;
    const source = map.getSource(layerId);
    const coordinates = trajectory[mavId].coordinates;

    if (source) {
        // Update the existing source data
        source.setData({
            type: 'FeatureCollection',
            features: [{
                type: 'Feature',
                geometry: {
                    type: 'LineString',
                    coordinates: coordinates,
                },
            }],
        });
    } else {
        // Add new trajectory layer
        map.addSource(layerId, {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [{
                    type: 'Feature',
                    geometry: {
                        type: 'LineString',
                        coordinates: coordinates,
                    },
                }],
            },
        });

        map.addLayer({
            id: layerId,
            type: 'line',
            source: layerId,
            layout: {
                'line-join': 'round',
                'line-cap': 'round',
            },
            paint: {
                'line-color': color,
                'line-width': 2,
            },
        });
    }
};

export { VehicleMapIcon, TargetPositionMarker, HomePositionMarker, createOrUpdateLine, updateTrajectoryLayer, getVehicleMaterialColor };